

export class ClientMeasure {
    SamplingId!: number;
    MeasureReferenceCode!: string;
    MeasureReferenceName!: string;
    MeasureReferenceDesignation!: string;

    ParentName!: string;
    // ZoneUsage: EZoneUsage = 0;
    // ProcessType: ESiteType;
    SamplingDate!: Date;
    SampleCode!: string;
    PumpWithBattery!: boolean;
    Rush!: boolean;
    HasAreaMap!: boolean;


    ChipName!: string;
    TextColor!: string;
    Color!: string;

    static mapFromJSON(json: any): ClientMeasure {
        const cm = new ClientMeasure;

        cm.SamplingId = json['samplingId'];
        cm.MeasureReferenceCode = json['measureReferenceCode'];
        cm.MeasureReferenceName = json['measureReferenceName'];
        cm.MeasureReferenceDesignation = json['measureReferenceDesignation'];
        cm.ChipName = json['measureReferenceChipName'];
        cm.Color = `#${json['measureReferenceColor']}`;
        cm.TextColor = `#${json['measureReferenceTextColor']}`;

        cm.ParentName = json['parentName'];
        // cm.ZoneUsage = json['zoneUsage'] === null ? 0 : json['zoneUsage'];
        // cm.ProcessType = json['processType'];
        cm.SamplingDate = json['samplingDate'];
        cm.SampleCode = json['sampleCode'];
        cm.PumpWithBattery = json['pumpWithBattery'];
        cm.Rush = json['rush'];
        cm.HasAreaMap = json['hasAreaMap'];

        return cm;
    }
}
